
export default function AboutHero() {
  return (
    <section 
      className="relative min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/7c733f736a8b6a8cb36389483ebd1e52.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            À Propos de <span className="text-red-500">COBRA SECURITE</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            Depuis plus de 25 ans, nous protégeons les entreprises avec des solutions 
            de sécurité innovantes et un service client d'excellence.
          </p>
          <div className="flex flex-col sm:flex-row gap-8 justify-center items-center text-center">
            <div>
              <div className="text-4xl font-bold text-red-500">25+</div>
              <div className="text-gray-300">Années d'expérience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-red-500">2500+</div>
              <div className="text-gray-300">Clients satisfaits</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-red-500">20+</div>
              <div className="text-gray-300">Techniciens experts</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
